import { getDictList } from '@/services/dictionary/DictionaryController';
import { useRequest } from 'ahooks';
import { useState } from 'react';

export default () => {
  const [dictList, setDictList] = useState([]);
  // 查询字典
  const getDictListReq = useRequest(getDictList, {
    manual: true,
    onSuccess: (data) => {
      console.log(data);
      setDictList(data);
    },
  });

  return { getDictListReq, dictList };
};
